module.exports = __webpack_public_path__ + "static/media/saveIcon.68317941.svg";